import React from 'react'
import Banner from '../components/Banner'
import Navbar from '../components/Navbar'
import ReachUs from '../components/ReachUs'

function ReachOut() {
    return (
        <div>
            <Banner />
            <Navbar />
            <ReachUs />
        </div>
    )
}

export default ReachOut